/**
 * Unwraps a filter value from the `{value: X}` wrapper form used by some
 * EagGrid filter types (e.g. DateRange, Slider).
 *
 * Returns the inner value when the wrapper is present, or the original value
 * unchanged.
 */
export const unwrapFilterValue = (raw: unknown): unknown => {
  if (typeof raw === 'object' && raw !== null && 'value' in (raw as Record<string, unknown>)) {
    return (raw as Record<string, unknown>).value;
  }
  return raw;
};

/**
 * Returns true when a filter value should be considered active (i.e. it has
 * a non-trivial value that filters the result set).
 *
 * A filter is **inactive** when its unwrapped value is:
 * - `null` or `undefined`
 * - `false`
 * - an empty array
 */
export const isFilterValueActive = (raw: unknown): boolean => {
  if (raw == null) {
    return false;
  }
  const value = unwrapFilterValue(raw);
  if (value == null || value === false) {
    return false;
  }
  if (Array.isArray(value) && value.length === 0) {
    return false;
  }
  return true;
};